import React, {useContext} from 'react';
import StrengthMeter from '../../../shared/strength-meter';
import QuoteContext from "../../quote-context";
import {LoadingFormButton} from '../../../shared/loading-button';

const Create = ({ processForm, siteId }) => {

	const { navigation, navigationDispatcher, formDispatcher, formData } = useContext(QuoteContext);

	const handleChange = ( e ) => {
		formDispatcher({type: "UPDATE_FIELD", key: e.target.name, value: e.target.value});
	};

	const handlePassword = ( password, isValid ) => {
		formDispatcher({type: "UPDATE_FIELD", key: "password", value: password});
		formDispatcher({type: "UPDATE_FIELD", key: "passwordValid", value: isValid});
	};

	const handleGdpr = (e) => {
		formDispatcher({type:"UPDATE_FIELD", key: e.target.name, value: e.target.checked ? true : false});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		processForm();
	}

	return (
		<form onSubmit={handleSubmit} id="quote-form-v3">
			<div className={navigation.error.code == 'ERR_NAME' ? `field-error form-field` : 'form-field'}>
				<label className="form-label"><span>Your full name:</span></label>
				<input className="form-input radius" type="text" name="name" value={formData.name} onChange={handleChange} data-hj-whitelist />
			</div>

			<div className={navigation.error.code == 'ERR_EMAIL' || navigation.error.code == 'ERR_EMAIL_FORMAT' ? `field-error` : null}>
				<label className="form-label"><span>Your email:</span></label>
				<input className="form-input radius" type="text" name="email" placeholder="example@youremail.com" value={formData.email} onChange={handleChange} />
			</div>

			<div className={navigation.error.code == 'ERR_PHONE' ? `field-error` : null}>
				<label className="form-label"><span>Your mobile number:</span></label>
				<input className="form-input radius" type="text" name="phone" placeholder="07777 123 456" value={formData.phone} onChange={handleChange} />
			</div>

			<div className={navigation.error.code == 'ERR_PASSWORD' ? `field-error` : null}>
				<label className="form-label"><span>Create password - This will give you access to view all your quotes and prices:</span></label>
				<StrengthMeter handleChange={handlePassword} name="password" value={formData.password} placeholder="Enter a new password"/>
			</div>

			{ siteId == 17 ? <Survey navigation={navigation} formData={formData} formDispatcher={formDispatcher} /> : null }
			
			<div className={navigation.error.code == 'ERR_PRIVACY' ? `field-error` : null}>
				<label className="form-label"><span>I’m happy to be contacted by {siteId == 1 ? "The Stag Company" : "Hen Party Deals"} about:</span></label>
				<div className="input-container radius mg-v">
					<div className="align-content vertical top">
						<input id="consent" type="checkbox" onChange={handleGdpr} name="consent" aria-label="consent" checked={formData.consent}></input>
						<label className="input-container__highlight" htmlFor="consent">
							<span className="checkbox-input"></span>
							<p className='text-small'>This and other relevant packages and I have read and understood the <a className="link small primary" onClick={(event) => navigationDispatcher( { type: 'OPEN_MODAL', modal: './modals/quote/privacy-info', title: 'Privacy notice', payload: { id: 1 }}, event )}>privacy notice<sup>*</sup></a></p>
						</label>
					</div>
				</div>
			</div>

			<div className="input-container radius mg-v">
				<input id="marketing" type="checkbox" onChange={handleGdpr} name="marketing" aria-label="marketing"></input>
				<label className="input-container__highlight" htmlFor="marketing">
					<span className="checkbox-input"></span>
					<p className='text-small nowrap'>Special offers and discounts</p>
				</label>
			</div>
		
			<label htmlFor="promo" className="button plain primary text-medium auto-dsk-up toggle mg-b">Got a promo code?</label>

			<input type="checkbox" id="promo" className="hide-input"/>
			<div className="toggle-content">
				<div className={navigation.error.code == 'PROMOTION_CODE' ? `field-error` : null}>
					<label className="form-label"><span>Promo code (optional)</span></label>
					<input className="form-input radius" type="text" name="code" value={formData.code} onChange={handleChange} data-hj-whitelist />
				</div>
			</div>

			<div className="mg-b">

				<LoadingFormButton
					value="Get price"
					processing={navigation.processing}
					buttonClass="button primary radius"
				/>

			</div>
			
			
		</form>
	)
}

const Survey = ({ navigation, formData, formDispatcher }) => {

	const handleSurvey = ( key, val ) => {
		formDispatcher({type:"UPDATE_SURVEY", key: key, value: val });	
	}
	
	return (
		<>
			<div className={navigation.error.code == 'ERR_SURVEY_ROLE' ? `field-error` : null}>
				<label className="form-label"><span>How involved are you in the planning of the hen party?</span></label>
				<div className="align-content vertical center wrap-mobile gap">
					<div className="custom-radio mg-b">
						<input 
							id="organiser"
							type="radio" 
							value={ 1 } 
							name="role"
							checked={ formData.survey.role == 1 }
							onChange={() => handleSurvey( 'role', 1 )}
						/>
						<label className="btn btn-default" htmlFor="organiser">Lead organiser</label>
					</div>
					<div className="custom-radio mg-b">
						<input
							id="coorganiser"
							type="radio" 
							value={ 2 } 
							name="role"
							checked={ formData.survey.role == 2 }
							onChange={() => handleSurvey( 'role', 2 )}
						/>
						<label className="btn btn-default" htmlFor="coorganiser">Co-organiser</label>
					</div>
					<div className="custom-radio mg-b">
						<input 
							id="guest"
							type="radio" 
							value={ 3 } 
							name="role"
							checked={ formData.survey.role == 3 }
							onChange={() => handleSurvey( 'role', 3 )}
						/>
						<label className="btn btn-default" htmlFor="guest">Party guest</label>
					</div>
				</div>
			</div>

			<div className={navigation.error.code == 'ERR_SURVEY_PLANNING' ? `field-error` : null}>
				<label className="form-label"><span>What stage of planning are you at?</span></label>
				<div className="align-content vertical center wrap-mobile gap">
					<div className="custom-radio mg-b">
						<input 
							id="inspo"
							type="radio" 
							value={ 1 } 
							name="stage" 
							checked={ formData.survey.stage == 1 }
							onChange={() => handleSurvey( 'stage', 1 )}
						/>
						<label className="btn btn-default" htmlFor="inspo">Looking for inspo</label>
					</div>
					<div className="custom-radio mg-b">
						<input 
							id="planning"
							type="radio" 
							value={ 2 } 
							name="stage" 
							checked={ formData.survey.stage == 2 }
							onChange={() => handleSurvey( 'stage', 2 )}
						/>
						<label className="btn btn-default" htmlFor="planning">Planning underway</label>
					</div>
					<div className="custom-radio mg-b">
						<input 
							id="ready"
							type="radio" 
							value={ 3 } 
							name="stage" 
							checked={ formData.survey.stage == 3 }
							onChange={() => handleSurvey( 'stage', 3 )}
						/>
						<label className="btn btn-default" htmlFor="ready">Ready to book</label>
					</div>
				</div>
			</div>
		</>
	)
}

export default Create;
